module.exports = __webpack_public_path__ + "static/img/29.5a13c306.png";